export default function hasSequentialNumbers(str: string) {
  for (let i = 0; i < str.length - 2; i++) {
    if (str.charCodeAt(i + 1) === str.charCodeAt(i) + 1
        && str.charCodeAt(i + 2) === str.charCodeAt(i) + 2) {
      return true;
    }
  }
  return false;
}
